/**
 *   Generated file. Do not edit
 */

import { AbstractService, ServiceCallType } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';
import * as serviceConverters from './service-converters';
import { converters as commonConverters } from '@iotize/tap/service/core';

const allConverters = {
  ...commonConverters,
  ...serviceConverters,
};

export const SERVICE_CALLS = {
  getEnabled: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/lte/enabled',
    path: '/1024//131',
    responseBodyDecoder: allConverters.boolean,
  } as ServiceCallType<void, boolean>,

  putEnabled: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/lte/enabled',
    path: '/1024//131',
    bodyEncoder: allConverters.boolean,
  } as ServiceCallType<boolean, void>,

  getApplicationData: {
    method: TapRequestFrame.MethodType.GET,
    pathAlias: '/lte/application-data',
    path: '/1024//122',
    responseBodyDecoder: allConverters.int8,
  } as ServiceCallType<void, number>,

  putApplicationData: {
    method: TapRequestFrame.MethodType.PUT,
    pathAlias: '/lte/application-data',
    path: '/1024//122',
  } as ServiceCallType<Uint8Array, void>,
};
